<template>
  <v-card flat class="pa-5 bg-background">
    <!-- fleet vehicles two column list -->
    <v-card-text class="text-h6 px-0 px-md-4">
      <v-row no-gutters class="mb-2 flex-nowrap">
        Available vehicles
        <v-spacer></v-spacer>
        <ElevatedBtn v-if="canAddVehicles" @click="handleAddVehicle" > Add vehicle </ElevatedBtn>
      </v-row>
      <v-text-field
        v-if="unfilteredData.length"
        v-model="searchQuery"
        bg-color="background"
        clearable
        placeholder="Search fleet for vehicles available to you..."
        class="mt-4"
      />
      <v-row v-if="connectedVehicles.length" no-gutters>
        <v-card
          flat
          v-for="(vehicle, index) in connectedVehicles"
          :key="'fleet-vehicle-' + index"
          :style="smAndDown ? 'width: 100%' : 'width: 50%'"
          class="py-1 pa-md-1"
        >
          <DashboardVehicleListCard :vehicle="vehicle" @click="emitViewVehicle(vehicle)" />
        </v-card>
      </v-row>
      <v-row
        v-else-if="searchQuery && unfilteredData.length"
        class="text-body-1 text-pwt_black my-4"
        no-gutters
      >
        No vehicles match your search query
      </v-row>
      <v-row v-else class="text-body-1 text-pwt_black my-4" no-gutters>
        You have no connected vehicles
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import Vehicle from '@/classes/vehicle_classes/vehicle'
import { GettersTypes, MainDialogContent, MutationTypes, type State } from '@/store/store_types'
import { computed, ref } from 'vue'
import { useDisplay } from 'vuetify'
import { useStore } from 'vuex'
import ElevatedBtn from '../ui-elements/buttons/ElevatedBtn.vue'
import DashboardVehicleListCard from './DashboardVehicleListCard.vue'

const { smAndDown } = useDisplay()
const store = useStore<State>()
const emit = defineEmits<{
  (e: 'view-vehicle', vehicle: Vehicle): void
  (e: 'add-vehicle'): void
}>()

const searchQuery = ref('')
const unfilteredData = computed<Vehicle[]>(() => store.getters[GettersTypes.stockVehicles])
const connectedVehicles = computed<Vehicle[]>(() => {
  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase()
    return unfilteredData.value.filter((vehicle) => {
      if (vehicle.name && vehicle.name.toLowerCase().includes(query)) return vehicle
      if (vehicle.VIN && vehicle.VIN.toLowerCase().includes(query)) return vehicle
      if (vehicle.licensePlate && vehicle.licensePlate.toLowerCase().includes(query)) return vehicle
      if (vehicle.evModel) {
        if (vehicle.evModel.name.toLowerCase().includes(query)) return vehicle
      }
    })
  }
  return unfilteredData.value
})
const customVehicles = computed<Vehicle[]>(() => store.getters[GettersTypes.customVehicles])

/**
 * Emits an event to view a vehicle. If the vehicle being viewed is the
 * same as the selected vehicle, the event emits `undefined` as the vehicle
 * ID. Otherwise, the event emits the local ID of the vehicle.
 *
 * @param {Vehicle} vehicle - The vehicle to be viewed.
 * @return {void} This function does not return anything.
 */
function emitViewVehicle(vehicle: Vehicle) {
  emit('view-vehicle', vehicle)
}


const canAddVehicles = computed(() => {
  {
    const canAdd = store.state.permissions.hasSpecificPermission('Car_Record', 'create', 'full')
    return canAdd
  }
})
function handleAddVehicle() {
  store.commit(MutationTypes.setMainDialogContent, MainDialogContent.ADD_VEHICLE)
}
</script>
<style scoped>

:deep(.v-field__input)::placeholder{
  opacity: 1 !important;
  color: #161616 !important;
  font-style: italic !important;
}

:deep(.v-field__input > input){
  padding-left: 2px !important;
}
:deep(.v-field__input){
  padding-left: 2px !important;
}

</style>
